import React, { useEffect } from "react";
import {
  SidePanelHeader,
  SidePanelBody,
  MenuComponent,
  SearchInput,
  IconButton,
  PillsGroup,
  SidePanel,
  TableView,
  Select,
  Link,
  Pill,
  Label,
  useTimeFrameComponent,
  TimeFrame,
} from "@gpstrackit/gtc-react-controls";
import { useIntl } from "react-intl";
import { Grid } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";

const DEFAULTFRAME = "last30Days";

export const HistoryFilter = ({ showSidePanel, setShowSidePanel, date, setDate }) => {
  const { messages } = useIntl();
  const timeFrameOptions = [
    { id: "today", label: messages["date_last_today"] },
    { id: "yesterday", label: messages["date_last_yesterday"] },
    { id: "last7days", label: messages["date_last_7days"] },
    { id: "last30Days", label: messages["date_last_30days"] },
    { id: "custom", label: messages["date_custom"] },
  ];

  const timeFrame = useTimeFrameComponent(timeFrameOptions, DEFAULTFRAME);
  const { user } = useSelector((state) => state.securityRedux);

  useEffect(() => {
    timeFrame.defaultvalue(DEFAULTFRAME)
  }, [])

  useEffect(() => {
    const { startDate, endDate, option } = timeFrame;
    if (startDate && endDate) setDate({ start: startDate, end: endDate, option });
  }, [timeFrame?.startDate, timeFrame?.endDate]);

  return (
    <SidePanel
      isOpen={showSidePanel}
      onToggle={() => setShowSidePanel(!showSidePanel)}
      style={{ width: "350px", transform: "translateX(350px)" }}
    >
      <SidePanelHeader>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <h2 style={{ margin: 0 }}>
              {messages["vehicleView_advancedFilters"]}
            </h2>
          </Grid>
        </Grid>
      </SidePanelHeader>
      <SidePanelBody>
        <Grid>
          <Label>{messages["clipRequestAdvancedTimeFrame"]}</Label>
          <div className="time-frame-container">
            <TimeFrame
              {...timeFrame}
              placeholder={messages["reportsMainRT_timeFrame"]}
              maxDate={moment()}
              filterSwitch={false}
              withTime={true}
              minDate={moment().subtract(90, "d")}
              dateFormat={user?.dateformat || "MM/DD/YYYY hh:mm A"}
            />
          </div>
        </Grid>
      </SidePanelBody>
    </SidePanel>
  );
};
